import React from 'react'
import PropTypes from 'prop-types'
import Records from './Records'
import * as UI from '../Shared.styles'
import { SPEAKABLE_SUMMARY } from 'constant'
import BrandsSchemasHelmet from './BrandsSchemasHelmet'


const BrandResultList = ({ records }) =>
  <>
    <BrandsSchemasHelmet />

    <UI.Wrapper role="main" data-at-brand-results-list-wrapper>
      <UI.Title data-at-title headline centered>Shop By Tire Brand</UI.Title>
      <UI.Description data-at-description className={ SPEAKABLE_SUMMARY }>
        Big O Tires brings the world’s best tire brands together under one roof.
      </UI.Description>
      <Records records={ records } />
    </UI.Wrapper>
  </>

BrandResultList.propTypes = {
  records: PropTypes.arrayOf(PropTypes.shape())
}

BrandResultList.type = 'BrandResultList'

export default BrandResultList
